import React from 'react';
import {Link} from 'react-router-dom';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import FontAwesome from 'react-fontawesome';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import '../common/sortable-list.css';

/** @class HallBoothsList
  * A component which lists the booths of a hall.
  */
export default class HallBoothList extends ReactFireComponent {
  /** @constructor
    * Constructs a new HallBoothsList instance
    */
  constructor(props) {
    super(props);
    this.boothURL = `/expos/${this.props.expoID}/booths`
    this.dataURL = `/expos/${this.props.expoID}/halls/${this.props.hallID}/booths`;
    this.state = {booths:[]}
    this.handleNewBooth = this.handleNewBooth.bind(this);
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.togglePublished = this.togglePublished.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding data
    * in the Firebase realtime database.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'booths');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the Firebase database.
    */
  componentWillUnmount() {
    this.unbind('booths');
  }
  /** @function handleNewBooth
    * Creates a new booth for the hall.
    */
  handleNewBooth(){
    const metadata = {
      name: "New Booth",
      published: false
    }
    const newBooth = {
      metadata: metadata,
      halls: {[this.props.hallID]: true},
      contents: {}
    };
    var key = firebase.database().ref(this.boothURL).push().key;
    var updates = {
      [`${this.dataURL}/${key}`]: metadata,
      [`${this.boothURL}/${key}`]: newBooth
    }
    firebase.database().ref().update(updates);
  }
  /** @function handleSortEnd
    * Applies user-sorting to the booth list.
    * @param {Object} {oldIndex, newIndex} the
    * two items to swap in the booth list.
    */
  handleSortEnd({oldIndex, newIndex}){
    var booths = arrayMove(this.state.booths, oldIndex, newIndex);
    var updates = {}
    booths.forEach((booth, i) => {
      updates[`${this.dataURL}/${booth.id}/order`] = i + 1;
    });
    firebase.database().ref().update(updates);
  }
  /** @function handleRemove
    * Removes the booth from the hall.
    * NOTE: The booth still exists in the expo.
    * @param {string} boothID - the id of the booth to remove
    */
  handleRemove(boothID){
    if(window.confirm("Are you sure?  This will remove the booth from the hall (it will still exist in the show's booths)")) {
      var updates = {
        [`${this.dataURL}/${boothID}`]: null,
        [`${this.boothURL}/${boothID}/halls/${this.props.hallID}`]: null
      }
      firebase.database().ref().update(updates);
    }
  }
  /** @function togglePublished
    * Toggles the published status of the specified booth.
    * @param {Object} booth - the booth to publish
    */
  togglePublished(boothID){
    // Step 1: get the actual booth
    firebase.database().ref(`${this.boothURL}/${boothID}`)
    .once('value').then(snapshot => {
      const booth = snapshot.val();
      // Step 2: Update published status for booth and its halls
      const published = !booth.metadata.published;
      var updates = {
        [`${this.boothURL}/${boothID}/metadata/published`]: published
      };
      Object.keys(booth.halls).forEach(hallID => {
        var url = `/expos/${this.props.expoID}/halls/${hallID}/booths/${boothID}/published`;
        updates[url] = published;
      });
      firebase.database().ref().update(updates);
    });
  }
  /** @function render
    * Renders the component.
    */
  render() {
    return (
      <div className="hall-booth-list">
        <label>Booths</label>
        <SortableList
          expoID={this.props.expoID}
          items={this.state.booths}
          useDragHandle={true}
          onSortEnd={this.handleSortEnd}
          onTogglePublished={this.togglePublished}
          onRemoveBooth={this.handleRemove}
          />
        <button onClick={this.handleNewBooth}>
          <FontAwesome name="plus"/>
          Add New Booth
        </button>
      </div>
    );
  }
}

/* A Drag handle for the sortable list */
const DragHandle = SortableHandle(() => <FontAwesome name="reorder"/>);

/* An item in the sortable list */
const SortableListItem = SortableElement((props) => {
  return(
    <div className="sortable-list-item">
      <DragHandle />
      {props.booth.name}
      <span>
        <FontAwesome name={props.booth.published?'flag':'flag-o'}
          style={{color:"#4eba6f", cursor: "pointer"}}
          onClick={props.onTogglePublished}
          />
        <Link to={props.dataURL}>
          <FontAwesome name="edit"
            style={{color:"#965ba5", cursor:"pointer"}}/>
        </Link>
        <FontAwesome name="times"
          style={{color:"red", cursor: "pointer"}}
          onClick={props.onRemoveBooth}
          />
      </span>
    </div>
  );
});

/* The sortable list */
const SortableList = SortableContainer((props) => {
  return (
    <div className="sortable-list">
      {props.items.map((booth, index) => (
        <SortableListItem
          key={booth.id}
          index={index}
          booth={booth}
          dataURL={`/expos/${props.expoID}/booths/${booth.id}`}
          onTogglePublished={()=>{props.onTogglePublished(booth.id)}}
          onRemoveBooth={()=>{props.onRemoveBooth(booth.id)}}
          />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/hall-editor/hall-booth-list.js